import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { ERROR_REPORTING_PACKAGE_NAME } from '../../common/constants';
import type { SubTasksEnabledResourceData } from './types';

export const getIsIssueTypeSubTasksEnabled = async (): Promise<SubTasksEnabledResourceData> => {
	try {
		return await fetchJson('/rest/internal/3/issuetype/subtask/enabled');
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getIsIssueTypeSubTasksEnabledRequest',
				packageName: ERROR_REPORTING_PACKAGE_NAME,
				teamName: 'morphinecake',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
